import { Label, LABEL_COMPACT_SIZE } from '../../Label'

import * as styles from './EntityLabelList.module.css'

function EntityLabelList({ className = styles.EntityLabelList, labels }) {
  return labels?.length > 0 ? (
    <div className={className}>
      {labels.map(label => {
        return (
          <Label
            backgroundColor={label.color}
            className={styles.label}
            height={LABEL_COMPACT_SIZE}
            key={label.id}
            text={label.name}
          />
        )
      })}
    </div>
  ) : null
}

export default EntityLabelList
